import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchNotFound = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M60 112.499C88.995 112.499 112.5 88.9945 112.5 59.9997C112.5 31.0049 88.995 7.5 60 7.5C31.0051 7.5 7.5 31.0049 7.5 59.9997C7.5 88.9945 31.0051 112.499 60 112.499Z",
			fill: "#00B5FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.2977 59.9504C67.3133 57.2022 78.2058 64.2214 80.4403 67.1217C82.6749 70.0219 68.7077 75.5086 67.3956 85.8033C66.6604 91.5718 64.0994 95.4654 59.6328 98.9251C61.4565 91.5519 61.6288 85.6568 53.1682 81.4405C44.7076 77.2243 37.1519 69.9743 39.8882 67.1217C42.6245 64.269 52.6489 57.5685 53.7176 59.9504C55.6491 64.2552 58.7821 68.189 60.1547 68.189C61.5273 68.189 64.3869 65.1209 66.2977 59.9504Z",
			fill: "#00B5FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.6696 35.4942C59.8485 34.8298 60.7911 34.8298 60.97 35.4942L61.87 38.8367C62.8682 42.5443 65.7643 45.4404 69.4719 46.4387L72.8144 47.3386C73.4788 47.5175 73.4788 48.4601 72.8144 48.639L69.4719 49.539C65.7643 50.5372 62.8682 53.4333 61.87 57.1409L60.97 60.4834C60.7911 61.1478 59.8485 61.1478 59.6696 60.4834L58.7697 57.1409C57.7714 53.4333 54.8753 50.5372 51.1677 49.539L47.8252 48.639C47.1608 48.4601 47.1608 47.5175 47.8252 47.3386L51.1677 46.4387C54.8753 45.4404 57.7714 42.5443 58.7697 38.8367L59.6696 35.4942Z",
			fill: "#00B5FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M101.768 91.8107C92.1767 104.386 77.0362 112.5 60.0008 112.5C42.9653 112.5 27.8248 104.386 18.2333 91.8107C29.1825 87.6913 43.8624 85.1727 60.0008 85.1727C76.1391 85.1727 90.8183 87.6913 101.768 91.8107Z",
			fill: "#00B5FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.175 34.9959L79.2307 34.8808C79.2307 30.3809 81.7653 29.495 84.4598 28.7642C87.1544 28.0334 88.3665 23.0873 93.0487 22.8059C95.8138 22.6396 97.264 23.3512 98.465 24.2675C98.4666 24.2691 98.4666 24.2707 98.4682 24.2707C101.477 27.5081 104.066 31.1115 106.175 34.9959Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.3174 68.4318L8.18982 68.523C7.82894 66.317 7.60994 64.0902 7.53418 61.8563C12.162 61.2006 11.6887 57.5227 17.2153 57.8569C21.3154 58.1031 22.3804 62.4351 24.7391 63.0748C27.0979 63.7144 29.3174 64.4924 29.3174 68.4318Z",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.8886 37.37C27.681 38.4126 27.9587 39.4991 28.2784 40.2155C28.6057 40.9491 28.2764 41.8091 27.5428 42.1364C26.8092 42.4638 25.9491 42.1344 25.6218 41.4008C25.1596 40.3648 24.6692 38.6421 25.0356 36.8019C25.4226 34.8587 26.7215 33.0136 29.4079 31.8149C32.094 30.6165 34.5665 30.856 36.4004 32.12C38.1805 33.3469 39.1688 35.4138 39.1958 37.5068C39.2101 38.6247 38.913 39.5311 38.5611 40.2958C38.3918 40.664 38.2033 41.0121 38.0388 41.316L38.0352 41.3226C37.8629 41.641 37.7149 41.9147 37.5846 42.1946C37.3344 42.7321 37.1774 43.2363 37.1669 43.8349C37.1562 44.4417 37.2949 45.2526 37.8008 46.3864C38.1281 47.12 37.7988 47.98 37.0652 48.3073C36.3316 48.6347 35.4716 48.3053 35.1442 47.5717C34.5074 46.1444 34.2386 44.9094 34.2583 43.784C34.2782 42.6503 34.5893 41.7361 34.9473 40.9669C35.1163 40.604 35.3016 40.2617 35.463 39.9635L35.477 39.9377C35.6487 39.6206 35.7936 39.3513 35.9185 39.0799C36.1576 38.5601 36.294 38.0922 36.287 37.5443C36.2711 36.3058 35.6824 35.1582 34.7495 34.5152C33.8704 33.9093 32.4939 33.6235 30.5933 34.4715C28.6929 35.3194 28.0757 36.4306 27.8886 37.37Z",
			fill: "#00B5FE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 38.7856,
			cy: 52.1777,
			r: 2.0625,
			transform: "rotate(-24.0457 38.7856 52.1777)",
			fill: "#00B5FE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M86.6778 16.6743C85.3484 17.5201 84.4693 18.9306 84.0295 20.0069C83.5792 21.109 82.3206 21.6373 81.2185 21.1869C80.1164 20.7366 79.5881 19.4781 80.0385 18.376C80.6745 16.8195 82.0172 14.5294 84.3634 13.0367C86.8411 11.4603 90.148 10.9613 94.1839 12.6105C98.2193 14.2596 100.496 17.153 101.021 20.4121C101.53 23.5755 100.329 26.7515 98.1151 28.9247C96.9325 30.0853 95.6574 30.6956 94.4779 31.1022C93.9101 31.298 93.3442 31.4528 92.8502 31.5879L92.8394 31.5908C92.3219 31.7324 91.8771 31.8543 91.4438 32.0015C90.6118 32.2842 89.9109 32.6326 89.2591 33.2346C88.5983 33.8448 87.8719 34.8241 87.1758 36.5275C86.7254 37.6296 85.4669 38.158 84.3648 37.7076C83.2627 37.2572 82.7344 35.9987 83.1847 34.8966C84.061 32.7522 85.1083 31.1992 86.3339 30.0673C87.5684 28.9272 88.8663 28.3237 90.0569 27.9192C90.6186 27.7284 91.1751 27.5762 91.6599 27.4437L91.7018 27.4322C92.2173 27.2912 92.6542 27.1705 93.0728 27.0262C93.8745 26.7498 94.5155 26.4166 95.0951 25.8477C96.4052 24.5618 97.0312 22.7556 96.7642 21.0978C96.5125 19.5355 95.4084 17.7684 92.553 16.6016C89.6981 15.4349 87.8756 15.9122 86.6778 16.6743Z",
			fill: "#00B5FE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 81.9821,
			cy: 43.5152,
			r: 3.17511,
			transform: "rotate(22.2269 81.9821 43.5152)",
			fill: "#00B5FE"
		})
	] }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("rect", {
		width: 120,
		height: 120,
		fill: "white"
	}) })]
});
export default SvgSearchNotFound;
